import { FaBullhorn, FaCalendarAlt } from "react-icons/fa";
import { useState } from "react";

import TabDetail from "../../../../models/TabDetail.model";
import Tabs from "../../../UI/Tabs/Tabs";
import { LONG_TERM_PROMOTION_SUB_TAB_ID, SHORT_TERM_PROMOTION_SUB_TAB_ID } from "../../../../shared/constants";
import LongTermPromotionGrid from "./LongTermPromotionGrid";
import ShortTermPromotionGrid from "./ShortTermPromotionGrid";
import PromoMasterSlicers from "./PromoMasterSlicers";

const PromoMasterTab = () => {
    // States
    const [gridChangeTrackStates, setGridChangeTrackStates] = useState<{ [key: string]: boolean; }>({
        [LONG_TERM_PROMOTION_SUB_TAB_ID]: false,
        [SHORT_TERM_PROMOTION_SUB_TAB_ID]: false
    });

    // Variables
    const upperSectionSubTabs: TabDetail[] = [
        {
            id: LONG_TERM_PROMOTION_SUB_TAB_ID,
            name: "Long Term Promotion",
            icon: <FaCalendarAlt />,
            content: <LongTermPromotionGrid gridHeight="25vh" getChangeTrackState={(changeTrackState: boolean) => setChangeTrackState(LONG_TERM_PROMOTION_SUB_TAB_ID, changeTrackState)} />
        }
    ];
    const lowerSectionSubTabs: TabDetail[] = [
        {
            id: SHORT_TERM_PROMOTION_SUB_TAB_ID,
            name: "Short Term Promotion",
            icon: <FaBullhorn />,
            content: <ShortTermPromotionGrid gridHeight="25vh" getChangeTrackState={(changeTrackState: boolean) => setChangeTrackState(SHORT_TERM_PROMOTION_SUB_TAB_ID, changeTrackState)} />
        }
    ];

    const setChangeTrackState = (gridTabId: string, newChangeTrackState: boolean) => {
        setGridChangeTrackStates((prev) => ({
            ...prev,
            [gridTabId]: newChangeTrackState
        }))
    };

    return (
        <div className="container-fluid">
            <div className="row mb-2">
                <div className="col col-12 text-start">
                    <PromoMasterSlicers isGridChanged={gridChangeTrackStates[LONG_TERM_PROMOTION_SUB_TAB_ID] || gridChangeTrackStates[SHORT_TERM_PROMOTION_SUB_TAB_ID]} />
                </div>
            </div>

            <Tabs
                tabs={upperSectionSubTabs}
                activeTabIndex={0}
                getActiveTabId={(tabId: string) => {}}
            />

            <div className="mt-2">
                <Tabs
                    tabs={lowerSectionSubTabs}
                    activeTabIndex={0}
                    getActiveTabId={(tabId: string) => {}}
                />
            </div>
        </div>
    );
};

export default PromoMasterTab;
